import { useEffect } from "react";
import {
  Alert,
  Box,
  Button,
  Checkbox,
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
  Link,
  Grid,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { format } from "date-fns";

import "dayjs/locale/de";

import React, { useState } from "react";
import phone from "../../data/phone.json";
import InputSelect from "./InputSelect";
import InputSelectPays from "./InputSelectPays";
import { useNavigate } from "react-router-dom";

import { setSteep } from "../../app/services/reservationSlice";
import { useAddReservationMutation } from "../../app/services/reservationApi";
import { useSelector, useDispatch } from "react-redux";
import ChangeInfo from "./ChangeInfo";
// import RecapRetraitInfo from "./RecapRetraitInfo";
import Conditions from "./Conditions";
import CustomTabPanel from "./ReservationClient";
import Loader from "../loader/Loader";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";

import Bureau from "./Bureau";

function Coordonnes() {
  const navigate = useNavigate();
  const state = useSelector((state) => state.change.value);
  const stateRetrait = useSelector((state) => state.reservation.value);

  const dateActuelle = dayjs();
  const dateActuelleFormatee = format(dateActuelle.toDate(), "dd/MM/yyyy");
  const [dateRetrait, setDateRetrait] = useState(dayjs());
  const [heureRetrait, setHeureRetrait] = useState();
  const [bureauId, setBureauId] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [reservation, setReservation] = useState({
    user_id: 1,
    nomFamille: "",
    nomFamille2: "",
    prenom: "",
    email: "",
    indicatif: "+212 (MA)",
    // dateNaissance: dayjs("2022-04-20"),
    // paysDocIdentite: "Morocco",
    montantToExchange: state.montantToExchane,
    MontantToReceive: state.MontantToReceive,
    typeOperation: state.typeOperation,
    devise: state.cour.devise.name,
    devise_id: state.cour.devise_id,
    cour_id: state.cour.id,
    taux:
      state.typeOperation === "achat"
        ? state.cour.prixAchat
        : state.cour.prixVente,
    // bureauRetrait: stateRetrait.bureauRetrait,
    dateRetrait: dateRetrait,
    heureRetrait: heureRetrait,
    telephone: "",
    adresse: "",
  });

  const [addReservation, { data: reservation1, isLoading, isError, error }] =
    useAddReservationMutation();

  const [giveSelectValue, setGiveSelectValue] = useState("");
  const members = phone?.map((phone) => (
    <MenuItem value={phone.name} key={phone.code}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {phone.code} {phone.dial_code}
      </Box>
    </MenuItem>
  ));

  const [isChecked, setIsChecked] = useState(false);
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  // Confirmation email
  const [email, setEmail] = useState("");
  const [confirmEmail, setConfirmEmail] = useState("");
  const [message, setMessage] = useState("");
  const [errorEmail, setErrorEmail] = useState("");
  const [errorPhone, setErrorPhone] = useState(""); // État pour les erreurs de téléphone

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  useEffect(() => {
  setReservation((prev) => ({
    ...prev,
    dateRetrait: dateRetrait,
  }));
}, [dateRetrait]);
  // Effect to update button state when checkbox state changes
  useEffect(() => {
    setIsButtonEnabled(isChecked);
  }, [isChecked]);
  useEffect(() => {
    if (reservation.montantToExchange === 0) {
      alert(
        "Votre session de réservation a expiré. Veuillez recommencer le processus pour finaliser votre réservation. Merci de votre compréhension !"
      );
      navigate("/reservation");
    }
    // Remettre le défilement en haut de la page à chaque chargement
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    // Modifier seulement `steep` à 1 lors du chargement du composant
    dispatch(setSteep(2));
  }, [dispatch]);
  // Function to handle checkbox change
  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  // Function to validate phone number
  const validatePhoneNumber = (phoneNumber) => {
    const phoneRegex = /^[1-9]\d{8}$/;
    return phoneRegex.test(phoneNumber);
  };

  const handleForm = (e) => {
    e.preventDefault();
    // Validate phone number
    if (!validatePhoneNumber(reservation.telephone)) {
      setErrorPhone(
        "Veuillez saisir un numéro de téléphone valide. Exemple: 6 XX XX XX XX"
      );
      return;
    } else {
      setErrorPhone("");
    }

    if (email !== confirmEmail) {
      setErrorEmail("Les adresses email ne correspondent pas.");
      return;
    }

    // message de test
    // console.log("reservattttion:::", reservation);

    setLoading(true);
    addReservation(reservation)
      .then((data) => {
        if (data && data.data && data.data.id) {
          navigate(`/reservation/confirmation/${data.data.id}`);
        } else {
          
          alert(
            "Le serveur est momentanément indisponible. Veuillez réessayer plus tard. Merci pour votre patience",
            data.data.id
          );
        }
      })
      .catch((error) => {
        alert("Erreur : les données de réservation sont manquantes");
        console.error("Erreur lors de l'ajout de la réservation :", error);
        setMessage(
          "La réservation n'a pas abouti. Veuillez réessayer plus tard merci."
        );
        setErrorEmail("");

        if (error.originalStatus === 500) {
          console.error("Erreur serveur. Veuillez réessayer plus tard.");
          alert("Erreur serveur. Veuillez réessayer plus tard.");
        } else if (error.status === "PARSING_ERROR") {
          console.error(
            "Erreur de parsing. La réponse n'est pas du JSON valide."
          );
          alert("Erreur de parsing. La réponse n'est pas du JSON valide.");
        } else {
          console.error("Une erreur inattendue s'est produite.");
          alert("Une erreur inattendue s'est produite.", error.message);
          console.log(error);
        }
      })
      .finally(() => {
        setLoading(false); // Set loading to false after API call
      });
  };

  // Handle indicatif change
  const handleIndicatifChange = (newIndicatif) => {
    setReservation((state) => ({
      ...state,
      indicatif: newIndicatif,
    }));
  };

  const handleChangeHeure = (event) => {
    setReservation((s) => ({ ...s, heureRetrait: event.target.value }));
  };
  // Fonction pour comparer les heures passées
  const estPasse = (heurePlage) => {
    const [debut, fin] = heurePlage.split(" - ");
    const maintenant = dayjs();
    return maintenant.isAfter(
      dayjs(`${dateRetrait.format("YYYY-MM-DD")} ${fin}`)
    );
  };

    const handleChangeDateRetrait = (newValue) => {
    if (newValue && dayjs(newValue).isValid()) {
      setDateRetrait(newValue);
      console.log("Date sélectionnée :", newValue.format("YYYY-MM-DD"));
      console.log("Date dateRetrait :", dateRetrait);
    }
  };

  // Liste des plages horaires
  const heuresDisponibles = [
    "08:00 - 10:00",
    "10:00 - 12:00",
    "12:00 - 14:00",
    "14:00 - 16:00",
    "16:00 - 18:00",
    "18:00 - 20:00",
    "22:00 - 23:59",
  ];

  return (
    <Stack>
      <Box
        sx={{
          backgroundColor: "white",
          borderRadius: 2,
          border: "solid 1px goldenrod",
        }}
      >
        <Box
          sx={{
            backgroundColor: "goldenrod",
            borderRadius: "8px 8px 0 0",
            pl: 2,
          }}
        >
          <Typography variant="h5">J'enregistre mes coordonnées</Typography>
        </Box>
        <Box
          sx={{
            padding: 2,
          }}
        >
          {loading ? (
            <Loader />
          ) : (
            <form onSubmit={handleForm}>
              <Grid
                container
                rowSpacing={2}
                columnSpacing={{ xs: 1, sm: 2, md: 3 }}
              >
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    fullWidth
                    label="Nom de famille"
                    id="nomFamille"
                    name="nomFamille"
                    size="small"
                    value={reservation.nomFamille}
                    onChange={(e) =>
                      setReservation((s) => ({
                        ...s,
                        nomFamille: e.target.value,
                      }))
                    }
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Prénom"
                    id="prenom"
                    size="small"
                    value={reservation.prenom}
                    onChange={(e) =>
                      setReservation((s) => ({ ...s, prenom: e.target.value }))
                    }
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    fullWidth
                    label="Email"
                    id="email"
                    size="small"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    fullWidth
                    label="Confirmer Email"
                    id="email2"
                    size="small"
                    value={confirmEmail}
                    onChange={(e) => {
                      setConfirmEmail(e.target.value);
                      setReservation((s) => ({ ...s, email: e.target.value }));
                    }}
                  />
                </Grid>

                {errorEmail && (
                  <Grid item xs={12}>
                    <Alert severity="warning">{errorEmail}</Alert>
                  </Grid>
                )}
                {message && (
                  <Grid item xs={12}>
                    <Typography>{message}</Typography>
                  </Grid>
                )}

                <Grid item xs={12} sm={6}>
                  <Grid container spacing={2} justifyContent={"space-between"}>
                    <Grid item xs={4} sm={4}>
                      <InputSelect
                        value={reservation.indicatif}
                        onChange={(val) =>
                          setReservation((prev) => ({
                            ...prev,
                            indicatif: val,
                          }))
                        }
                      />
                    </Grid>
                    <Grid item xs={6} sm={6}>
                      <TextField
                        required
                        fullWidth
                        label="Téléphone"
                        id="telephone"
                        size="small"
                        value={reservation.telephone}
                        onChange={(e) =>
                          setReservation((s) => ({
                            ...s,
                            telephone: e.target.value,
                          }))
                        }
                      />
                    </Grid>
                    {errorPhone && (
                      <Grid item xs={12}>
                        <Alert severity="warning">{errorPhone}</Alert>
                      </Grid>
                    )}
                  </Grid>
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Adresse"
                    id="adresse"
                    size="small"
                    multiline
                    maxRows={4}
                    onChange={(e) =>
                      setReservation((s) => ({ ...s, adresse: e.target.value }))
                    }
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label="Date de retrait"
                      value={dateRetrait}
                      onChange={(date) => setDateRetrait(dayjs(date))}
                      minDate={dateActuelle}
                      slotProps={{
                        textField: { fullWidth: true, size: "small" },
                      }}
                    />
                  </LocalizationProvider> */}
            
<LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        label="Date de retrait"
        value={dateRetrait}
        onChange={handleChangeDateRetrait}
        minDate={dateActuelle}
        slotProps={{
          textField: { fullWidth: true, size: "small" },
        }}
      />
    </LocalizationProvider>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="heure-label">Heure de retrait</InputLabel>
                    <Select
                      label="Heure de retrait"
                      labelId="heure-label"
                      id="heure-select"
                      onChange={handleChangeHeure}
                      value={heureRetrait}
                    >
                      {(dateRetrait.isSame(dateActuelle, "day")
                        ? heuresDisponibles.filter((h) => !estPasse(h))
                        : heuresDisponibles
                      ).map((heure) => (
                        <MenuItem key={heure} value={heure}>
                          {heure}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  {errorMessage && (
                    <Typography color="error">{errorMessage}</Typography>
                  )}
                </Grid>

                {bureauId && (
                  <Grid item xs={12}>
                    <Box>{<Bureau id={bureauId} />}</Box>
                  </Grid>
                )}

                {/* <Grid item xs={12}>
      <Conditions />
    </Grid> */}

                <Grid item xs={12}>
                  <Stack direction="row" spacing={1}>
                    <Checkbox
                      color="primary"
                      checked={isChecked}
                      onChange={handleCheckboxChange}
                    />
                    <Typography sx={{ mt: 1 }}>
                      J'ai lu et j'accepte&nbsp;
                      <Link href="/conditions" target="_blank" rel="noopener">
                        la politique de confidentialité et les conditions
                        générales
                      </Link>
                    </Typography>
                  </Stack>
                </Grid>

                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    type="submit"
                    disabled={!isButtonEnabled}
                  >
                    Passer ma réservation
                  </Button>
                </Grid>
                {state.typeOperation !== "achat" && (
                  <Grid item xs={12}>
                    <Typography variant="body2">
                      Merci de présenter vos documents d'identité au moment du
                      retrait
                    </Typography>
                  </Grid>
                )}
              </Grid>
            </form>
          )}
        </Box>
      </Box>
    </Stack>
  );
}

export default Coordonnes;
